<template>
  <div class="svg-wrap" v-loading="loading">
    <div ref="container" style="width: 100%;height:100%;">
    </div>
    <el-popover placement="bottom" trigger="manual" :visible-arrow="false" :content="content" v-model="visible" popper-class="d3-scale-percent">
      <div class="btn" slot="reference" @click="visible = !visible"></div>
    </el-popover>
  </div>
</template>

<script>
import { getEnterpriseGraph } from '@/views/clue/api/newClueApi'
import EquityPenetration from '@/components/D3Tree/equityPenetration'
import { v4 as uuidV4 } from 'uuid'
export default {
  name: 'EquityPenetration',
  components: {

  },
  props: {

  },
  data() {
    return {
      visible: false,
      content: '100%',
      loading: false
    }
  },
  mounted() {
    this.getEnterpriseGraph()
  },
  methods: {
    async getEnterpriseGraph() {
      this.loading = true
      const { hid, companyName } = this.$route.query
      const { code, data } = await getEnterpriseGraph({ hid, type: 1 })
      this.loading = false

      EquityPenetration.prototype.emit = this.percentHandle
      const tree = new EquityPenetration(this.$refs.container, {
        props: {
          label: 'name',
          children: 'child'
        }
      })
      // 上面是股东 下面是控股企业
      const treeData = []

      let maxMoney = 0
      let maxName = ''
      const [gd] = data.child.filter(e => e.nodeType == 2)
      const [kgqy] = data.child.filter(e => e.nodeType == 8)
      gd.child.forEach(e => {
        const percent = parseFloat(e.percent || 0)
        if (maxMoney < percent) {
          maxName = e.name
          maxMoney = percent
        }
      })
      treeData[0] = {
        ...data, child: gd.child.map(e => {
          if (e.name == maxName) return { ...e, headLabel: '实际控制人', beneficiaryShare: e.percent }
          return e
        })
      }
      treeData[1] = { ...data, child: kgqy.child }
      tree.create(treeData)
    },
    percentHandle(scale) {
      this.visible = true
      this.content = Math.floor(scale * 100) + '%'
      this.timer && clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.visible = false
      }, 1000)
    },
  }
}
</script>

<style scoped lang="scss">
@import "~/src/views/clue/page/style/enterprise.scss";
</style>
